export default "__VITE_ASSET__B6bYbFz0__"